import React from 'react';
import styled from 'styled-components';
import { Container, Button } from '../../common';

const NavbarPrimaryDesktopCtaButton = ({ sanity }) => {
  const { navbars, pages } = sanity;
  const action = navbars?.navCtaButtonAction; // ✅ FIXED
  const label = navbars?.navCtaButtonLabel;

  if (!action || !label) return null;

  const linkType = action?.actionType;

  const buttonProps = {
    sanity,
    label,
    linkType,
  };

  switch (linkType) {
    case 'page':
      buttonProps.internalLink = action?.page?.slug?.current || '/';
      break;
    case 'section':
      buttonProps.jumpLink = `#${action?.sectionId || ''}`;
      break;
    case 'modal':
      buttonProps.linkType = 'form';
      buttonProps.onClick = () => {
        const modal = document.getElementById(action?.modalId);
        if (modal) modal.classList.add('open');
      };
      break;
    default:
      return null;
  }

  return (
    <Container
      padding="none"
      classes="absolute inset-y-0 right-0 hidden items-center pr-2 sm:static sm:inset-auto sm:pr-0 lg:flex"
    >
      <div className="hidden sm:flex sm:items-center">
        <Button {...buttonProps} />
      </div>
    </Container>
  );
};

export { NavbarPrimaryDesktopCtaButton };
